<div class="one-row">
    <h1 mat-dialog-title>Tierbemerkungen</h1>
    <span class="spacer"></span>
    <mat-checkbox [checked]="showHistory" (change)="toggleShowHistory()">Historie anzeigen</mat-checkbox>
</div>

<div mat-dialog-content>
    <div
        *ngIf="!gruppenBemerkungen"
        style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            margin: 20% 0;
        "
    >
        <mat-hint>Lade Tierbemerkungen...</mat-hint>
    </div>

    <div *kienePermission="[9191]" style="margin-bottom: 12px">
        <div style="max-width: 40vw">
            <mat-hint class="hinweis-text">
                Hier aufgelistete Bemerkungen bitte zur Kenntnis nehmen und das Tier bei Bedarf erneut sichten, um dem
                Grund nachzugehen. Danach kann die Bemerkung abgehakt werden.
            </mat-hint>
        </div>

        <div *ngFor="let gruppenBemerkung of gruppenBemerkungen" style="margin-bottom: 12px">
            <div style="margin-left: 6px">
                <h4 style="margin-block-end: 0" class="green"
                    >{{ gruppenBemerkung.kunde }} {{ gruppenBemerkung.zusatz }} - {{ gruppenBemerkung.gruppe }}</h4
                >
                <div *ngFor="let tier of gruppenBemerkung.tiere">
                    <div style="margin: 6px 0 0 6px">
                        <strong>Ohrmarke: {{ tier.ohrmarke_notnull }}</strong>
                        <table aria-label="" style="width: 100%">
                            <tbody>
                                <tr
                                    *ngFor="let bemerkung of tier.bemerkungen"
                                    class="bemerkung"
                                    (click)="updateGruppenBemerkungRow($event, bemerkung)"
                                >
                                    <td>
                                        <mat-checkbox
                                            [checked]="isTierarztChecked(bemerkung.tierarzt)"
                                            (change)="updateGruppenBemerkung($event, bemerkung)"
                                            clickStopPropagation
                                        >
                                        </mat-checkbox>
                                    </td>
                                    <td>{{ bemerkung.bemerkung }}</td>
                                    <td>{{ bemerkung.vorname?.substring(0, 1) }}. {{ bemerkung.nachname }}</td>
                                    <td style="text-align: end">{{ bemerkung.erstellt | date: "dd.MM.YY HH:mm" }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <mat-divider></mat-divider>
        </div>
    </div>
    <div *kienePermission="[3931]">
            <div class="one-row">
                <h4> Kunde Bemerkungen</h4>
                <span class="spacer"></span>
                <button
                    *kienePermission="[3932]"
                    mat-icon-button
                    color="accent"
                    (click)="createKundenBemerkung()"
                    style="padding-right: 6px"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <table aria-label="" style="width: 100%">
                <tbody>
                    <tr
                        *ngFor="let bemerkung of kundeBemerkungen"
                        class="bemerkung"
                        (click)="createKundenBemerkung(bemerkung)"
                    >
                        <td>
                            <mat-checkbox
                                [checked]="isTierarztChecked(bemerkung.tierarzt)"
                                (change)="markAsRead(bemerkung)"
                                [disabled]="!localStorageService.currentUserHasPermission(3932)"
                                clickStopPropagation
                            >
                            </mat-checkbox>
                        </td>
                        <td>{{ bemerkung.bemerkung }}</td>
                        <td>{{ bemerkung.vorname?.substring(0, 1) }}. {{ bemerkung.nachname }}</td>
                        <td style="text-align: end">{{ bemerkung.erstellt | date: "dd.MM.YY HH:mm" }}</td>
                    </tr>
                </tbody>
            </table>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="dialogRef.close()">Schlie&szlig;en</button>
</div>
